(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-freebies-library"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFreebiesLibraries = (root = document) => {
      root.querySelectorAll('[data-freebies-library]').forEach((section) => {
        if (section.dataset.freebiesLibraryInitialized === 'true') {
          return;
        }

        const filters = Array.from(section.querySelectorAll('[data-freebies-filter]'));
        const cards = Array.from(section.querySelectorAll('[data-category-handle]'));
        const emptyState = section.querySelector('[data-freebies-empty]');

        if (!filters.length || !cards.length) {
          return;
        }

        section.dataset.freebiesLibraryInitialized = 'true';

        const setActiveFilter = (activeButton) => {
          const filterValue = activeButton.dataset.freebiesFilter;
          let visibleCount = 0;

          filters.forEach((button) => {
            button.setAttribute('aria-pressed', button === activeButton ? 'true' : 'false');
          });

          cards.forEach((card) => {
            const shouldShow = filterValue === 'all' || card.dataset.categoryHandle === filterValue;
            card.hidden = !shouldShow;

            if (shouldShow) {
              visibleCount += 1;
            }
          });

          if (emptyState) {
            emptyState.hidden = visibleCount > 0;
          }
        };

        filters.forEach((button) => {
          button.addEventListener('click', () => setActiveFilter(button));
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initFreebiesLibraries());
    } else {
      initFreebiesLibraries();
    }

    document.addEventListener('shopify:section:load', (event) => initFreebiesLibraries(event.target));
    document.addEventListener('shopify:section:select', (event) => initFreebiesLibraries(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-seminar-course-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSeminarCarousels = (root = document) => {
      root.querySelectorAll('[data-seminar-course-carousel]').forEach((section) => {
        if (section.dataset.seminarCarouselInitialized === 'true') {
          return;
        }

        const track = section.querySelector('[data-seminar-course-track]');
        const previousButton = section.querySelector('[data-seminar-carousel-prev]');
        const nextButton = section.querySelector('[data-seminar-carousel-next]');

        if (!track || !previousButton || !nextButton) {
          return;
        }

        section.dataset.seminarCarouselInitialized = 'true';

        let animationFrame;

        const updateArrowVisibility = () => {
          const hasOverflow = track.scrollWidth > track.clientWidth + 1;
          previousButton.hidden = !hasOverflow;
          nextButton.hidden = !hasOverflow;
        };

        const scrollCarousel = (direction) => {
          const card = track.querySelector('[data-seminar-course-card]');
          const styles = window.getComputedStyle(track);
          const gap = parseFloat(styles.columnGap || styles.gap || 0);
          const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
          const start = track.scrollLeft;
          const maxScroll = track.scrollWidth - track.clientWidth;
          const target = Math.max(0, Math.min(start + direction * amount, maxScroll));
          const duration = 420;
          const startedAt = window.performance.now();

          if (animationFrame) {
            window.cancelAnimationFrame(animationFrame);
          }

          track.style.scrollSnapType = 'none';

          const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);

          const animate = (currentTime) => {
            const elapsed = currentTime - startedAt;
            const progress = Math.min(elapsed / duration, 1);

            track.scrollLeft = start + (target - start) * easeOutCubic(progress);

            if (progress < 1) {
              animationFrame = window.requestAnimationFrame(animate);
            } else {
              track.style.scrollSnapType = '';
              animationFrame = undefined;
            }
          };

          animationFrame = window.requestAnimationFrame(animate);
        };

        previousButton.addEventListener('pointerdown', (event) => event.preventDefault());
        nextButton.addEventListener('pointerdown', (event) => event.preventDefault());
        previousButton.addEventListener('click', () => scrollCarousel(-1));
        nextButton.addEventListener('click', () => scrollCarousel(1));

        updateArrowVisibility();

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(updateArrowVisibility);
          resizeObserver.observe(track);
        } else {
          window.addEventListener('resize', updateArrowVisibility);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSeminarCarousels());
    } else {
      initSeminarCarousels();
    }

    document.addEventListener('shopify:section:load', (event) => initSeminarCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCustomTestimonialsCarousels = (root = document) => {
      root.querySelectorAll('[data-custom-testimonials-carousel]').forEach((section) => {
        if (section.dataset.customTestimonialsInitialized === 'true') {
          return;
        }

        const track = section.querySelector('[data-custom-testimonials-track]');
        const previousButton = section.querySelector('[data-custom-testimonials-prev]');
        const nextButton = section.querySelector('[data-custom-testimonials-next]');

        if (!track || !previousButton || !nextButton) {
          return;
        }

        section.dataset.customTestimonialsInitialized = 'true';

        let animationFrame;
        let currentIndex = 0;
        const originalCards = Array.from(track.querySelectorAll('[data-custom-testimonial-card]'));

        originalCards.slice().reverse().forEach((card) => {
          const beforeClone = card.cloneNode(true);

          beforeClone.setAttribute('aria-hidden', 'true');
          beforeClone.removeAttribute('data-custom-testimonial-card');

          track.insertBefore(beforeClone, track.firstChild);
        });

        originalCards.forEach((card) => {
          const afterClone = card.cloneNode(true);

          afterClone.setAttribute('aria-hidden', 'true');
          afterClone.removeAttribute('data-custom-testimonial-card');

          track.appendChild(afterClone);
        });

        const getStep = () => {
          const card = track.querySelector('[data-custom-testimonial-card]');
          const styles = window.getComputedStyle(track);
          const gap = parseFloat(styles.columnGap || styles.gap || 0);

          return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        };

        const getVisibleCount = () => {
          const styles = window.getComputedStyle(track);
          const cardsPerView = parseInt(styles.getPropertyValue('--testimonial-cards-per-view'), 10);

          return Number.isNaN(cardsPerView) ? 1 : cardsPerView;
        };

        const getBaseScroll = () => getStep() * originalCards.length;

        const jumpToIndex = (index) => {
          track.style.scrollSnapType = 'none';
          track.scrollLeft = getBaseScroll() + getStep() * index;
          track.style.scrollSnapType = '';
        };

        const updateArrowVisibility = () => {
          const hasOverflow = originalCards.length > getVisibleCount();
          previousButton.hidden = !hasOverflow;
          nextButton.hidden = !hasOverflow;
        };

        const scrollCarousel = (direction) => {
          if (originalCards.length <= getVisibleCount()) {
            return;
          }

          const start = track.scrollLeft;
          const nextIndex = currentIndex + direction;
          const target = getBaseScroll() + getStep() * nextIndex;
          const duration = 420;
          const startedAt = window.performance.now();

          if (animationFrame) {
            window.cancelAnimationFrame(animationFrame);
          }

          track.style.scrollSnapType = 'none';

          const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);

          const animate = (currentTime) => {
            const elapsed = currentTime - startedAt;
            const progress = Math.min(elapsed / duration, 1);

            track.scrollLeft = start + (target - start) * easeOutCubic(progress);

            if (progress < 1) {
              animationFrame = window.requestAnimationFrame(animate);
            } else {
              currentIndex = nextIndex;

              if (currentIndex >= originalCards.length) {
                currentIndex = 0;
                jumpToIndex(currentIndex);
              } else if (currentIndex < 0) {
                currentIndex = originalCards.length - 1;
                jumpToIndex(currentIndex);
              } else {
                track.style.scrollSnapType = '';
              }

              animationFrame = undefined;
            }
          };

          animationFrame = window.requestAnimationFrame(animate);
        };

        previousButton.addEventListener('pointerdown', (event) => event.preventDefault());
        nextButton.addEventListener('pointerdown', (event) => event.preventDefault());
        previousButton.addEventListener('click', () => scrollCarousel(-1));
        nextButton.addEventListener('click', () => scrollCarousel(1));

        jumpToIndex(currentIndex);
        updateArrowVisibility();

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(() => {
            jumpToIndex(currentIndex);
            updateArrowVisibility();
          });
          resizeObserver.observe(track);
        } else {
          window.addEventListener('resize', () => {
            jumpToIndex(currentIndex);
            updateArrowVisibility();
          });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCustomTestimonialsCarousels());
    } else {
      initCustomTestimonialsCarousels();
    }

    document.addEventListener('shopify:section:load', (event) => initCustomTestimonialsCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initVideoTestimonials = (root = document) => {
      root.querySelectorAll('[data-video-testimonial-media]').forEach((media) => {
        if (media.dataset.videoTestimonialInitialized === 'true') {
          return;
        }

        const button = media.querySelector('[data-video-testimonial-play]');
        const iframe = media.querySelector('iframe');

        if (!button || !iframe) {
          return;
        }

        media.dataset.videoTestimonialInitialized = 'true';

        button.addEventListener('click', () => {
          const iframeUrl = new URL(iframe.src);

          iframeUrl.searchParams.set('autoplay', '1');
          iframe.src = iframeUrl.toString();
          media.classList.add('is-playing');
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initVideoTestimonials());
    } else {
      initVideoTestimonials();
    }

    document.addEventListener('shopify:section:load', (event) => initVideoTestimonials(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template--blog"]) return;
  try {
    
  class BlogArticleSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-blog-search-input]');
      this.results = this.querySelector('[data-blog-search-results]');
      this.status = this.querySelector('[data-blog-search-status]');
      this.form = this.querySelector('form');
      this.blogPath = this.normalizePath(this.dataset.blogUrl);
      this.limit = Number(this.dataset.resultsLimit || 10);
      this.minCharacters = Number(this.dataset.minCharacters || 2);
      this.abortController = null;
      this.debounceTimer = null;

      if (!this.input || !this.results || !this.status || !this.form) return;

      this.input.addEventListener('input', () => this.queueSearch());
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.search();
      });
    }

    queueSearch() {
      window.clearTimeout(this.debounceTimer);
      this.debounceTimer = window.setTimeout(() => this.search(), 250);
    }

    async search() {
      const query = this.input.value.trim();

      if (query.length < this.minCharacters) {
        this.clearResults();
        return;
      }

      this.setStatus(this.dataset.loadingMessage);

      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();

      try {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=${this.limit}&resources[options][fields]=title,body,tag,author`;
        const response = await fetch(url, { signal: this.abortController.signal });

        if (!response.ok) throw new Error(response.status);

        const data = await response.json();
        const articles = this.getArticles(data).filter((article) => this.isCurrentBlogArticle(article));

        if (articles.length === 0) {
          this.clearResults();
          this.setStatus(this.dataset.emptyMessage);
          return;
        }

        this.renderResults(articles);
        this.setStatus('');
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.clearResults();
        this.setStatus(this.dataset.errorMessage);
      }
    }

    getArticles(data) {
      if (data && data.resources && data.resources.results && Array.isArray(data.resources.results.articles)) {
        return data.resources.results.articles;
      }

      if (data && data.resources && Array.isArray(data.resources.articles)) {
        return data.resources.articles;
      }

      return [];
    }

    isCurrentBlogArticle(article) {
      if (!article || !article.url) return false;

      const articlePath = this.normalizePath(article.url);
      return articlePath.startsWith(`${this.blogPath}/`);
    }

    normalizePath(url) {
      const parsedUrl = new URL(url, window.location.origin);
      return parsedUrl.pathname.replace(/\/$/, '');
    }

    renderResults(articles) {
      this.results.replaceChildren();

      const list = document.createElement('ul');
      list.className = 'template-blog__article-search-list';

      articles.forEach((article) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        const content = document.createElement('span');
        const title = document.createElement('strong');
        const summary = document.createElement('p');
        const imageUrl = this.getImageUrl(article);

        item.className = 'template-blog__article-search-result';
        link.className = 'template-blog__article-search-link';
        link.href = article.url;
        content.className = 'template-blog__article-search-content';
        title.className = 'template-blog__article-search-result-title';
        title.textContent = article.title || '';
        summary.className = 'template-blog__article-search-result-summary';
        summary.textContent = this.truncateText(article.body || article.summary || '', 120);

        if (imageUrl) {
          const image = document.createElement('img');
          image.className = 'template-blog__article-search-image';
          image.src = imageUrl;
          image.alt = article.title || '';
          image.loading = 'lazy';
          link.append(image);
        }

        content.append(title);

        if (summary.textContent) {
          content.append(summary);
        }

        link.append(content);
        item.append(link);
        list.append(item);
      });

      this.results.append(list);
      this.results.hidden = false;
    }

    getImageUrl(article) {
      if (typeof article.image === 'string') return article.image;
      if (article.image && article.image.url) return article.image.url;
      if (article.featured_image && article.featured_image.url) return article.featured_image.url;
      return '';
    }

    truncateText(text, length) {
      const cleanText = text.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();

      if (cleanText.length <= length) return cleanText;

      return `${cleanText.slice(0, length).trim()}...`;
    }

    clearResults() {
      this.results.replaceChildren();
      this.results.hidden = true;
      this.setStatus('');
    }

    setStatus(message) {
      this.status.textContent = message || '';
      this.status.hidden = !message;
    }
  }

  if (!customElements.get('blog-article-search')) {
    customElements.define('blog-article-search', BlogArticleSearch);
  }

  } catch(e) { console.error(e); }
})();
})();
